import { render, staticRenderFns } from "./EventVar.vue?vue&type=template&id=1465a06c&scoped=true"
import script from "./EventVar.vue?vue&type=script&lang=js"
export * from "./EventVar.vue?vue&type=script&lang=js"
import style0 from "./EventVar.vue?vue&type=style&index=0&id=1465a06c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1465a06c",
  null
  
)

export default component.exports